import React from "react";
import { Helmet } from "react-helmet";

function Shop() {
  return (
    <>
      <Helmet>
        <title>Boutique</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        Invitez vos amis
      </h1>
      <div className="mb-4 rounded px-1 py-1 sm:py-4 md:py-5 mt-5">
        <p className="text-gray-700 mb-4">
          Vous recevrez des promotions pour chaque achat effectué par les
          personnes que vous avez invitées.{" "}
          <span className="poppins-bold">
            Les revenus d'affiliation sont illimités.
          </span>{" "}
          Inviter plusieurs personnes peut vous rapporter des promotions
          importantes.
        </p>

        <p className="text-gray-700 mb-4">
          Vous pouvez également utiliser notre section{" "}
          <span className="poppins-bold">Promotion de parrainage</span> pour
          obtenir des filleuls.
        </p>

        <h3 className="mt-7 text-sm sm:text-base md:text-lg poppins-bold text-center text-black py-2 md:py-3 underline">
          Programme de partenariat
        </h3>

        <div class="grid grid-cols-3 justify-center gap-x-3 mt-2">
          <div class="h-full rounded-lg mb-6 flex flex-col relative overflow-hidden shadow-xl border border-pink-400">
            <div class="text-sm sm:tex-base lg:text-lg text-center text-pink-600 poppins-bold mt-4 px-2 md:px-4">
              Achat de produit par 50 filleul
            </div>
            <div class="pt-4 px-4 flex rounded-lg items-center text-gray-900">
              <p className="text-xs md:text-sm lg:text-base text-center">
                Gagner une reduction de{" "}
                <span className="poppins-semibold">
                  10% sur votre achat pendant 2 mois
                </span>
              </p>
            </div>
          </div>

          <div class="h-full rounded-lg mb-6 flex flex-col relative overflow-hidden shadow-xl border border-pink-400">
            <div class="text-sm sm:tex-base lg:text-lg poppins-bold text-pink-600 mt-4 text-center px-2 md:px-4">
              Achat de produit par 50 filleul
            </div>
            <div class="pt-4 pl-4 pr-4 flex rounded-lg items-center text-gray-900">
              <p className="text-xs md:text-sm lg:text-base text-center">
                Gagner une reduction de{" "}
                <span className="poppins-semibold">
                  10% sur votre achat pendant 6 mois
                </span>
              </p>
            </div>
          </div>

          <div class="h-full rounded-lg mb-6 flex flex-col relative overflow-hidden shadow-xl border border-pink-400">
            <div class="text-sm sm:tex-base lg:text-lg poppins-bold text-black mt-4 text-center px-2 md:px-4">
              Achat de produit par 50 filleul
            </div>
            <div class="pt-4 px-4 flex rounded-lg items-center text-gray-900">
              <p className="text-xs md:text-sm lg:text-base text-center">
                Gagner une reduction de{" "}
                <span className="poppins-semibold">
                  10% sur votre achat pendant un an
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Shop;
